/* eslint-disable func-names */
import { Instrumentation, LocalStorageAdapter } from '../types';

export default function (instrumentation?: Instrumentation): LocalStorageAdapter {
  const logError = function (error: Error) {
    if (instrumentation && instrumentation.logError) {
      instrumentation.logError(error.message);
    } else {
      console.error(error.message); // eslint-disable-line no-console
    }
  };

  const LocalStorage: LocalStorageAdapter = {
    supportsStorage() {
      try {
        return window && 'localStorage' in window && window.localStorage != null;
      } catch (err) {
        logError(err as Error);
        return false;
      }
    },
    set(key: string, data: unknown) {
      const str = JSON.stringify(data);
      try {
        window.localStorage.setItem(key, str);
      } catch (err) {
        try {
          window.localStorage.clear();
          window.localStorage.setItem(key, str);
        } catch (innerErr) {
          logError(innerErr as Error);
        }
      }
    },
    get<T = unknown>(key: string) {
      let result = null;
      try {
        const str = window.localStorage.getItem(key);
        if (str) {
          result = JSON.parse(str);
        }
      } catch (err) {
        logError(err as Error);
      }
      return result as T;
    },
    invalidate(key: string) {
      try {
        window.localStorage.removeItem(key);
      } catch (err) {
        logError(err as Error);
      }
    },
    clear() {
      try {
        window.localStorage.clear();
      } catch (err) {
        logError(err as Error);
      }
    },
    keys() {
      return Object.getOwnPropertyNames(window.localStorage);
    },
    type: 'localStorage',
  };
  return LocalStorage;
}
